import { connect } from 'react-redux';
import { fetchJournalDetails, fetchJournals } from '../actions';
import JournalSelection from './JournalSelection';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var serviceDetails = _ref.serviceDetails;
  var alwaysDisplayed = _ref2.alwaysDisplayed,
    required = _ref2.required,
    _ref2$validatesJourna = _ref2.validatesJournalSelection,
    validatesJournalSelection = _ref2$validatesJourna === void 0 ? true : _ref2$validatesJourna,
    serviceIdentities = _ref2.serviceIdentities,
    methods = _ref2.methods;
  return {
    alwaysDisplayed: alwaysDisplayed,
    displayed: alwaysDisplayed || serviceDetails.journalDetails.requested,
    methods: methods,
    required: required || serviceDetails.journalDetails.required,
    serviceIdentities: serviceIdentities,
    validatesJournalSelection: validatesJournalSelection
  };
};
export var mapDispatchToProps = {
  fetchJournals: fetchJournals,
  fetchJournalDetails: fetchJournalDetails
};
export default connect(mapStateToProps, mapDispatchToProps)(JournalSelection);